import { SvgIcon, SxProps } from "@mui/material";
import SquarePollSvg from "jsx:../../../Images/Icons/FontAwesome/solid/square-poll-horizontal.svg";

export function SquarePollSolidIcon(props: SxProps) {
    return <SvgIcon component={SquarePollSvg} inheritViewBox sx={props} />;
}
